import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import {
  SearchLandingPageModalTypes,
  useSearchLandingPageModals,
} from '../../hooks/useSearchLandingPageModals';

interface SearchLandingPageModalContext {
  currentModal: SearchLandingPageModalTypes | null;
  displayModal: (modalName: SearchLandingPageModalTypes) => void;
  hideModal: () => void;
}

const SearchLandingPageModalContext = createContext<SearchLandingPageModalContext | undefined>(
  undefined,
);

export const useSearchLandingPageModalContext = (): SearchLandingPageModalContext => {
  const context = useContext(SearchLandingPageModalContext);
  if (context === undefined) {
    throw new Error(
      'SearchLandingPageModalContext must be used within a SearchLandingPageModalContext.Provider',
    );
  }
  return context;
};

export const SearchLandingPageModalContextProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const {
    Modals,
    setCurrentModal: displayModal,
    hideModal,
    currentModal,
  } = useSearchLandingPageModals();
  const contextValue: SearchLandingPageModalContext = {
    currentModal,
    displayModal,
    hideModal,
  };

  return (
    <SearchLandingPageModalContext.Provider value={contextValue}>
      {children}
      <Modals />
    </SearchLandingPageModalContext.Provider>
  );
};
